
import "./loading-spinner.css";
import Logo from "./Logo";

export default function LoadingSpinner(props){
  return <Logo className="loading-spinner" fill="#ddd"/>
}